import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/base/baseWarehouse/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/base/baseWarehouse',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/base/baseWarehouse',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/base/baseWarehouse/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/base/baseWarehouse',
    method: 'get',
    params: {
      id
    }
  })
}

export function listOption(params) {
  return request({
    url: '/api/base/baseWarehouse/listOption',
    method: 'get',
    params
  })
}